(() => {
  if (window.__gcDesignCardAnalyticsBound) return;
  window.__gcDesignCardAnalyticsBound = true;

  const dedupeWindow = 30 * 60 * 1000;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest('[data-gc-design-card] a[href]');
    if (!link) return;

    const card = link.closest('[data-gc-design-card]');
    const designKey = card?.dataset.designKey || '';
    const source = card?.dataset.gcDesignSource || '';
    if (!designKey || !source) return;
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;

    const storageKey = `gc-design-click:${source}:${designKey}`;
    const now = Date.now();

    try {
      const previous = Number(window.sessionStorage.getItem(storageKey) || 0);
      if (previous && now - previous < dedupeWindow) return;
      window.sessionStorage.setItem(storageKey, String(now));
    } catch (error) {
      window.__gcDesignCardStorageError = error?.name || 'unavailable';
    }

    const cards = Array.from(document.querySelectorAll('[data-gc-design-card]'));
    const payload = {
      designKey,
      designStyle: card.dataset.gcDesignStyle || '',
      productHandle: card.dataset.productHandle || '',
      source,
      position: Math.max(cards.indexOf(card) + 1, 1),
      destination: link.pathname,
    };

    window.Shopify.analytics.publish('gocraftly:design_card_clicked', payload).catch((error) => {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (storageError) {
        window.__gcDesignCardStorageError = storageError?.name || 'unavailable';
      }
      window.__gcDesignCardAnalyticsError = error?.name || 'publish_failed';
    });
  });
})();
